// The articles API returns tyres and wheels (veljed) in one list and cannot
// filter by group server-side, so the catalogue tabs split them by MainGroupId.
export const WHEEL_GROUPS = [
  { id: 220, label: "Valuvelg" },
  { id: 210, label: "Plekkvelg" },
  { id: 215, label: "Veokivelg" },
];

const WHEEL_GROUP_IDS = new Set(WHEEL_GROUPS.map((group) => group.id));

export function isWheel(article) {
  return WHEEL_GROUP_IDS.has(Number(article?.MainGroupId));
}

// Everything that is not a wheel counts as a tyre, so new tyre groups
// show up without changes here.
export function matchesCategory(article, category) {
  return category === "wheels" ? isWheel(article) : !isWheel(article);
}

export function wheelGroupLabel(article) {
  const group = WHEEL_GROUPS.find(
    (entry) => entry.id === Number(article?.MainGroupId)
  );
  return group ? group.label : "";
}
